import { BookingState } from '../state';
import { SideEffectGenerator } from '../types';
import { bookingEffects } from './bookingEffects';
import { i18nEffects } from './i18nEffects';
import { locationsEffects } from './locationEffects';
import { priceEffects } from './priceEffects';
import { timeGeoEffects } from './timeGeoEffects';
import { uxStateEffects } from './uxStateEffects';
import { promoCodeEffects } from './promoCodeEffects';

export const sideEffects: SideEffectGenerator<BookingState>[] = [
  ...bookingEffects,
  ...timeGeoEffects,
  ...locationsEffects,
  ...priceEffects,
  ...i18nEffects,
  ...uxStateEffects,
  ...promoCodeEffects,
];
